import { invoiceParty } from "../../domain/invoicing.js";
import { esc } from "../../domain/format.js";

export function invoicePartySummary(value) {
  const party = invoiceParty(value);
  return `<div class="invoice-party"><strong>${esc(party.name || "Not recorded")}</strong> <div class="small muted">TIN ${esc(party.tin || "Not recorded")}</div> <div class="small muted">${esc(party.address || "Not recorded")}</div></div>`;
}
